var $25eb7c0c0c45e544$exports = {};
$25eb7c0c0c45e544$exports = {
  "close": "\u0417\u0430\u0442\u0432\u043E\u0440\u0438",
  "notifications": function notifications(args, formatter) {
    return "".concat(formatter.plural(args.count, {
      one: function one() {
        return "".concat(formatter.number(args.count), " \u0438\u0437\u0432\u0435\u0441\u0442\u0438\u0435");
      },
      other: function other() {
        return "".concat(formatter.number(args.count), " \u0438\u0437\u0432\u0435\u0441\u0442\u0438\u044F");
      }
    }), ".");
  }
};
export { $25eb7c0c0c45e544$exports as default };